export default __webpack_public_path__ + "locales/ar-SA/PaymentsEnterprise.json?hash=3ba35ba4bc55b0af2d206983284c4389";